import React, { useEffect, useState } from "react";
import AppShell from "../components/layout/AppShell";
import api, { fmtDate } from "../lib/api";
import { Link } from "react-router-dom";
import { FileSpreadsheet, Eye } from "lucide-react";
import StatusBadge from "../components/StatusBadge";

export default function RFQs() {
    const [items, setItems] = useState([]);
    useEffect(() => { api.get("/rfqs").then((r)=>setItems(r.data)); }, []);
    return (
        <AppShell title="RFQ & Teklifler" subtitle="Satın Alma">
            <div className="bg-card border border-border rounded-md">
                <div className="p-4 border-b border-border text-xs text-muted-foreground">
                    {items.length} RFQ • Onaylı taleplerden RFQ oluşturmak için Talepler sayfasını kullanın
                </div>
                <table className="data-table">
                    <thead>
                        <tr>
                            <th>No</th><th>Talep</th><th>Gönderim</th><th>Son Geçerlilik</th>
                            <th className="text-center">Tedarikçi</th>
                            <th>Durum</th><th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map(r => (
                            <tr key={r.id} data-testid={`rfq-row-${r.number}`}>
                                <td className="font-mono text-xs">{r.number}</td>
                                <td className="font-mono text-xs">{r.pr_number}</td>
                                <td>{fmtDate(r.sent_date)}</td>
                                <td>{fmtDate(r.expiry_date)}</td>
                                <td className="text-center tabular-nums">{r.supplier_ids?.length || 0}</td>
                                <td><StatusBadge status={r.status}/></td>
                                <td>
                                    <Link to={`/rfqs/${r.id}`}>
                                        <button className="inline-flex items-center gap-1.5 text-primary text-sm hover:underline" data-testid={`rfq-open-${r.number}`}>
                                            <FileSpreadsheet size={14}/> Karşılaştır
                                        </button>
                                    </Link>
                                </td>
                            </tr>
                        ))}
                        {items.length === 0 && (
                            <tr><td colSpan={7} className="text-center py-16 text-muted-foreground">Henüz RFQ yok</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </AppShell>
    );
}
